export default "__VITE_ASSET__f063649a__"